import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactSelect from 'components/theme/Select'
import {
  contactsWithEmailsSelector,
  contactsWithPhonesSelector,
} from '../../selectors'
import { toggleDialog } from 'actions/view'
import { setMergeFieldsPreviewSelect } from 'actions/tasks'
import { getContactsWithEmails } from 'actions/contacts'
import { list } from 'actions/data'

class MergeFieldsPreviewSelect extends Component {
  componentDidMount() {
    if (
      !this.props.contactsWithEmails?.length &&
      !this.props.contactsWithPhones?.length
    ) {
      this.props.getContactsWithEmails()
    }

    if (!this.props.users) {
      this.props.list('account/user', 'user_name')
    }
  }

  render() {
    const customStyles = {
      control: provided => ({
        ...provided,
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderRadius: '28px',
        padding: '9px 0',
      }),
      menu: provided => ({ ...provided, zIndex: 2 }),
    }
    return (
      <div>
        <ReactSelect
          styles={customStyles}
          value={this.props.value}
          onChange={newValue => {
            if (newValue.value === 'See more...') {
              return this.props.toggleDialog({
                open: true,
                dialog: 'contactList',
                options: {
                  type: 'template',
                },
              })
            }

            return this.props.setMergeFieldsPreviewSelect(newValue)
          }}
          options={
            this.props.selectedActionPrediction === 'email'
              ? [
                  { label: 'None', value: null },
                  { label: 'Sample preview contact', value: 'sample' },
                  ...(this.props.contactsWithEmails?.slice(0, 10) || []),
                  { label: 'See more...', value: 'See more...' },
                ]
              : [
                  { label: 'None', value: null },
                  { label: 'Sample preview contact', value: 'sample' },
                  ...(this.props.contactsWithPhones?.slice(0, 10) || []),
                  { label: 'See more...', value: 'See more...' },
                ]
          }
          placeholder="Contact to preview"
          isDisabled={this.props.disabled}
        />
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      value: state.tasks.addOrEdit.mergeFieldsPreviewSelect,
      contactsWithEmails: contactsWithEmailsSelector(state),
      contactsWithPhones: contactsWithPhonesSelector(state),
      selectedActionPrediction:
        state.tasks.addOrEdit.fields.selectedActionPrediction.value,
      users: state.data?.['account/user'],
    }
  },
    dispatch => {
      return bindActionCreators(
        {
          toggleDialog,
          setMergeFieldsPreviewSelect,
          getContactsWithEmails,
          list,
        },
        dispatch,
      )
    },
)(MergeFieldsPreviewSelect)
